import { render, staticRenderFns } from "./GenericUpload.vue?vue&type=template&id=73b9b230&"
import script from "./GenericUpload.vue?vue&type=script&lang=js&"
export * from "./GenericUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports